import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router';

/** Every path but `/login` lands on the sign-in screen, keeping `?next=…&client=…`. */
export function RedirectToLogin(): ReactElement {
  const location = useLocation();
  return <Navigate to={`/login${location.search}`} replace />;
}
